import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GeneralContactInfo } from '@src/types/contact';
import type { ErrorData } from '@types';

type Loading = 'fetch-contact';

type ContactRToolkitReducer<P = void> = (
  state: InitialState,
  action: PayloadAction<P>
) => void;

/**
 * A phone the contact just linked through a REQUEST_CONTACT_INFO request, received live
 * (`CONTACT_PHONE_LINKED`, ENG-1304). Kept apart from `contact` on purpose: replacing `contact`
 * reloads the whole contact form and drops the agent's unsaved edits, while this only patches
 * the phone.
 */
export type LinkedPhone = { contactId: number; mobileNumber: string };

type InitialState = {
  contact: GeneralContactInfo;
  error: ErrorData | null;
  loading: Loading[];
  linkedPhone: LinkedPhone | null;
};

const initialState: InitialState = {
  error: null,
  contact: {
    id: 0,
    botId: 0,
    fullName: '',
    identificationNumber: '',
    email: '',
    phoneNumber: '',
    mobileNumber: '',
    country: { isoCode: 'CO', name: 'Colombia', languageCode: 'es' },
    cityName: '',
    address: '',
    company: '',
    attributes: [],
    attributesAugmented: [],
  },
  loading: [],
  linkedPhone: null,
};

export type HandleFetchContactById = { id: string; viaBotAccount?: number };
export const handleFetchContactById: ContactRToolkitReducer<
  HandleFetchContactById
> = state => {
  state.loading.push('fetch-contact');
  state.error = null;
};

export type HandleFetchContactByIdSuccess = {
  bot: unknown;
  contact: GeneralContactInfo;
};

const handleFetchContactByIdSuccess: ContactRToolkitReducer<
  HandleFetchContactByIdSuccess
> = (state, action) => {
  state.contact = action.payload.contact;
};

const handleFetchContactByIdFailure: ContactRToolkitReducer<ErrorData> = (
  state,
  action
) => {
  state.error = action.payload;
};

const handleFetchContactByIdFulfill: ContactRToolkitReducer = state => {
  state.loading = state.loading.filter(l => l !== 'fetch-contact');
};

const handleContactPhoneLinked: ContactRToolkitReducer<LinkedPhone> = (
  state,
  action
) => {
  state.linkedPhone = action.payload;
};

const contactRToolkit = createSlice({
  name: 'Contact',
  initialState,
  reducers: {
    fetchContactById: handleFetchContactById,
    fetchFechContactByIdSuccess: handleFetchContactByIdSuccess,
    fetchFechContactByIdFailure: handleFetchContactByIdFailure,
    fetchFechContactByIdFulfill: handleFetchContactByIdFulfill,
    contactPhoneLinked: handleContactPhoneLinked,
  },
});

const { actions, reducer } = contactRToolkit;
export const {
  fetchContactById,
  fetchFechContactByIdSuccess,
  fetchFechContactByIdFailure,
  fetchFechContactByIdFulfill,
  contactPhoneLinked,
} = actions;

export default reducer;
